import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { StoreState } from '../../store'

import LinearProgress from '@material-ui/core/LinearProgress'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import CompareArrowsIcon from '@material-ui/icons/CompareArrows'

import { editingStart } from '../../store/transfers/transfersActions'
import { formatBrl } from '../../utils'
import moment from 'moment'

export default function TransfersList() {
  const { transfers, selectedIndex, isEditing, isLoading } = useSelector(
    ({ transfersState }: StoreState) => {
      return {
        transfers: transfersState.transfers,
        selectedIndex: transfersState.selectedIndex,
        isEditing: transfersState.isEditing,
        isLoading: transfersState.loadingTransfers,
      }
    }
  )

  const dispatch = useDispatch()
  const onClickItem = (index: number) => () => {
    dispatch(editingStart(index))
  }

  if (isLoading) {
    return <LinearProgress />
  }

  return (
    <List>
      {!transfers.length ? (
        <Box display="flex" justifyContent="center" color="gray" marginTop={1}>
          <Typography
            variant="caption"
            align="center"
            children="Nenhum registro encontrado"
          />
        </Box>
      ) : (
        transfers.map((transfer, i) => (
          <ListItem
            style={{
              boxShadow: '0px 4px 0px rgba(55, 55, 55, 0.1)',
              height: 80,
            }}
            key={i}
            button
            onClick={onClickItem(i)}
            selected={isEditing && selectedIndex === i}
          >
            <Box display="flex" flex={1} justifyContent="space-between">
              <Box>
                <Typography>
                  {transfer.resourceOrigin} para {transfer.resourceDestiny}
                </Typography>
                <CompareArrowsIcon style={{ color: '#00B9F2' }} />
                <Typography
                  style={{ color: '#00B9F2' }}
                  variant="caption"
                  children={formatBrl(transfer.value)}
                />
              </Box>
              <Box display="flex" flexDirection="column" alignItems="flex-end">
                <Typography
                  variant="caption"
                  children={moment(transfer.date).format('DD/MM/YYYY')}
                />
              </Box>
            </Box>
          </ListItem>
        ))
      )}
    </List>
  )
}
